import { Link } from "@reach/router";
import React from "react";

/**
 * Thin `@reach/router` `Link` wrapper living outside `newui/` (which bans a
 * direct `@reach/router` import) so `RfxListPage` can render route-derived
 * tab links without local `useState`.
 */
export const RfxTabLink: React.FC<{
	children: React.ReactNode;
	className?: string;
	"data-testid"?: string;
	isActive: boolean;
	to: string;
}> = ({ to, isActive, children, className, ...rest }) => (
	<Link
		to={to}
		role="tab"
		aria-selected={isActive}
		className={className}
		{...rest}
	>
		{children}
	</Link>
);
